import { FC } from 'react';
import { Check, X } from 'lucide-react';

interface AnswerIconProps {
  type: 'correct' | 'incorrect' | 'neutral';
}

const renderIconContent = (type: AnswerIconProps['type']) => {
  switch (type) {
    case 'correct':
      return (
        <Check className="text-(--neutral-white-NW1000) w-4 h-4 lg:w-6 lg:h-6" strokeWidth={1.5} />
      );
    case 'incorrect':
      return (
        <X className="text-(--neutral-white-NW1000) w-4 h-4 lg:w-6 lg:h-6" strokeWidth={1.5} />
      );
    case 'neutral':
    default:
      return null;
  }
};

const getIconClasses = (type: AnswerIconProps['type']) => {
  switch (type) {
    case 'correct':
      return 'bg-(--success-S600)';
    case 'incorrect':
      return 'bg-(--danger-D600)';
    case 'neutral':
    default:
      return 'border-2 border-(--neutral-black-NB300) bg-(--neutral-white-NW1000)';
  }
};

export const AnswerIcon: FC<AnswerIconProps> = ({ type }) => {
  return (
    <div
      className={`shrink-0 w-5 h-5 lg:w-8 lg:h-8 rounded-[6px] flex items-center justify-center ${getIconClasses(type)}`}
    >
      {renderIconContent(type)}
    </div>
  );
};
